import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import RestService from "./../../Restservice";
import Loader from "./../../component/Loader";
import CustomTable from "./../../component/CustomTable";
import GlobalHelmet from "./../../GlobalHelmet";
import Breadcrumbs from "./../../component/breadcrumbs";
import { makeStyles } from "@material-ui/core/styles";
import Common from "./../../common.json";
import AdvdecdFaq from "./AdvdecdFaq";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
});

export default function Advdecd() {
  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [column, setcolumn] = useState(1);
  const [getRec, setgetRec] = useState(false);
  function refreshPage() {
    var d = new Date();
    var n = d.getTime();
    setcolumn(n);
  }

  useEffect(() => {
    setLoading(true);
    RestService.getadvList(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setgetRec(response.data);
      },
      mobile,
      web_token
    );
  }, [column, mobile, web_token]);

  return (
    <>
      <GlobalHelmet {...Common?.advDec} />
      {loading ? <Loader /> : ""}
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              <div className="fixedAddButton">
                <button
                  className="btn btn-success"
                  title="Reload Page"
                  onClick={refreshPage}
                >
                  <i className="fa fa-refresh"></i>
                </button>{" "}
                &nbsp;
                <Link
                  className="btn btn-success"
                  to="/stock-market-today"
                >
                  <i className="fa fa-arrow-left"></i>{" "}
                </Link>
              </div>
              <Breadcrumbs page="ADV/DEC" />
              <h1 className="highlighttext">ADV/DEC</h1>
              <p>
              Get an advance decline ratio here. Advance decline ratio is an indicator of market breadth. Analyze advance decline ratio today to get insight of stock market strength for tomorrow and coming days. If advancing stocks number is increasing and declining stocks number is decreasing, then it is a good sign of a strong stock market. Analyze 30 days advance decline ratio and find the clue of market direction. This ratio in financial markets refers to a major change in direction for a security or the economy in general.
              </p>

              <div className={classes.root}>
                <div className="">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="tabelcontiner">
                        <div className="  pb-4 mb-4  ">
                          {!getRec ? (
                            ""
                          ) : (
                            <>
                              <CustomTable
                                key="dataField"
                                columndata={
                                  getRec.setColumn ? getRec.setColumn : ""
                                }
                                marketdata={getRec.getRec ? getRec.getRec : ""}
                                redirectlink="/stocks/"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 mt-4">
                        <AdvdecdFaq marketdata={getRec.getRec ? getRec.getRec : ""}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
